import { combineReducers } from 'redux';
import { channel } from './Reducers/Channel.reducer';

const staticReducers = {
    channel
};

const app = combineReducers(staticReducers);

export default app;
